var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50145 9.01085L0.00156212 20.269C3.98269 22.5675 8.71383 23.1904 13.1542 22.0006C17.5946 20.8108 21.3804 17.9058 23.6789 13.9247L30.1788 2.66652C26.1977 0.368015 21.4665 -0.254853 17.0262 0.93494C12.5858 2.12473 8.79995 5.02973 6.50145 9.01085Z",
    fill: "#E95C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapsed);
export default __webpack_public_path__ + "static/media/logo-collapsed.01aad2087ad7fe690afadd759f3c074e.svg";
export { ForwardRef as ReactComponent };